<template>
	<div class="mt-4 pt-4" style="min-width: 1rem;">
		<v-row>
			<v-text-field class="message-detail-promotional-code-text" light dense v-model="selectedPromocode" :label="$t('steppersale.promotionalcode')" @blur="handlePromotionalCode" autocomplete="null">
			</v-text-field>
		</v-row>
		<v-row class="mt-0" style="font-size: 12px;">
			<div id="message-detail-promotional-code">
				<span class="message-detail-promotional-code-true" style="display: none; color: #00cd00;"> {{ $t('steppersale.promocodecorrect') }} </span>
				<span class="message-detail-promotional-code-false" style="display: none; color: #FF0000;"> {{ $t('steppersale.promocodeinvalid') }} </span>
			</div>
		</v-row>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	data: () => ({
		selectedPromocode: ''
	}),

	methods: {
		...mapActions(['CALCULATE_TICKETS_PRICE']),
		handlePromotionalCode() {
			this.$emit('validatePromocode', this.selectedPromocode);
		}
	}
};
</script>

<style></style>
